// components/filters/MultiSelectFilters.jsx
import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import "./_custom.scss";

const MultiSelectFilters = ({ filters, onFilterChange, handleFilter, handleReset, filterHeight = "auto" }) => {
  return (
    <Row>
      {filters.map((filter) => (
        <Col
          xs={12} sm={6} md={4} lg={3}
          className="mt-2 filter-col"
          controlId={filter.controlId}
          key={filter.name}
          style={{ marginBottom: '15px' }}
        >
          <h6 className="text-uppercase" style={{ fontSize: '12px', marginBottom: '5px' }}>
            {filter.controlId}
          </h6>
          <div className="multi-select-wrapper" style={{ minHeight: filterHeight }}>
            <MultiSelect
              valueRenderer={(selected) => {
                if (selected.length === 0) return filter.labelledBy;

                if (selected.length === filter.options.length) {
                  return `All ${filter.controlId} are selected`;
                }

                if (selected.length === 1) {
                  return selected[0].label;
                }

                return `${selected.length} selected`;
              }}
              overrideStrings={{
                allItemsAreSelected: `${filter.allItems}`,
                selectSomeItems: filter.labelledBy,
              }}
              disableSearch={filter.disableSearch}
              hasSelectAll={filter.selectAll}
              options={filter.options}
              value={filter.value}
              onChange={(e) => onFilterChange(e, filter.name)}
              labelledBy={filter.name}
              className="custom-multi-select"
            />
          </div>
        </Col>
      ))}
      <Col sm={1.5} className='mt-4'>
        <Button
          variant="primary"
          onClick={handleFilter}
          className="mt-2 flex justify-content-center align-items-center"
        >
          Get Results
        </Button>
      </Col>
      <Col sm={1} className='mt-4'>
        <Button
          variant="secondary"
          onClick={handleReset}
          className="mt-2 flex justify-content-center align-items-center"
        >
          Reset
        </Button>
      </Col>
    </Row>
  );
};

export default MultiSelectFilters;